import { useContext, useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { LoaderContext } from "./store/LoaderContextProvider";
import Spinner from "./components/Spinner/Spinner";

export default function AppLayout() {
  const location = useLocation();
  const { isLoading, setIsloading } = useContext(LoaderContext);

  useEffect(() => {
    setIsloading(true);
    const timeout = setTimeout(() => setIsloading(false), 1000);
    return () => clearTimeout(timeout);
  }, [location, setIsloading]);

  return (
    <>
      {isLoading && <Spinner />}
      <Outlet />
    </>
  );
}
